window.addEventListener('DOMContentLoaded', (event) => {
    viewTrimmedImageGridImages();
    lightGalleryInit();
});

function lightGalleryInit() {
    const imageGridArray = document.querySelectorAll('.lightbox-grid');
    imageGridArray.forEach(imageGrid => {
        const imageGridId = imageGrid.getAttribute('id');
        $('#' + imageGridId).lightGallery({
            selector: '.image-grid-text__link',
            fullScreen: true,
            thumbnail: false
        });
    });
}

function viewTrimmedImageGridImages() {
    const btnArray = document.querySelectorAll('[view-more-btn]');
    btnArray.forEach(btn => {
        btn.addEventListener('click', function() {
            const parentGrid = btn.closest('.image-grid');
            const imgArray = parentGrid.querySelectorAll('.view-moreable');
            imgArray.forEach(e => {
                if (e.classList.contains('d-none')) {
                    e.classList.remove('d-none');
                    btn.innerText = "View Less";
                } else {
                    e.classList.add('d-none');
                    btn.innerText = "View More";
                }
            });
        })
    });

}